import { useQuery } from "@/api/swr/useQuery";
import { freeAssessmentSchema } from "@/schema/free-assessment/FreeAssessment";

type Config = Parameters<typeof useQuery<typeof freeAssessmentSchema>>[2];

export const useGetFreeAssessment = (config?: Config) => {
  return useQuery(freeAssessmentSchema, "/free_assessment/paper", config);
};
